import { useTranslation, Translation } from 'react-i18next';
import React, { useCallback } from 'react';
import { wrapModalPromise, WrapModalProps } from '@/utils';
import style from './index.module.css';
import { CommonModal } from '@/components/Modal/CommonModal';
import { useForm, Controller } from 'react-hook-form';
import Checkbox from 'antd/es/checkbox';

type ReportHiSessionModalProp = {
  onConfirm: (v?: string) => Promise<void>;
};

const REPORT_ITEMS = [
  {
    title: <Translation>{t => t('ReportHiSessionModal.1vaxq4c')}</Translation>,
    desc: <Translation>{t => t('ReportHiSessionModal.desc1')}</Translation>,
  },
  {
    title: <Translation>{t => t('ReportHiSessionModal.4r1exd')}</Translation>,
    desc: <Translation>{t => t('ReportHiSessionModal.harassment')}</Translation>,
  },
  {
    title: <Translation>{t => t('ReportHiSessionModal.1tae9j7')}</Translation>,
    desc: <Translation>{t => t('ReportHiSessionModal.desc3')}</Translation>,
  },
  {
    title: <Translation>{t => t('ReportHiSessionModal.1n34pw5')}</Translation>,
  },
  {
    title: <Translation>{t => t('ReportHiSessionModal.jhjkhi')}</Translation>,
  },
  {
    title: <Translation>{t => t('ReportHiSessionModal.18276kg')}</Translation>,
    desc: <Translation>{t => t('ReportHiSessionModal.desc4')}</Translation>,
  },
  {
    title: <Translation>{t => t('ReportHiSessionModal.title5')}</Translation>,
  },
];

const ReportHiSessionModal = ({ onConfirm, hide }: ReportHiSessionModalProp & WrapModalProps) => {
  const { t } = useTranslation();

  const confirmCallback = useCallback(
    async (data: { report: boolean[] }) => {
      const reason = data.report
        .map((checked, index) => {
          return checked ? REPORT_ITEMS[index].title : '';
        })
        .filter(Boolean)
        .join(', ');

      console.log('SUBMIT data', reason);
      onConfirm(reason);
      hide();
    },
    [hide, onConfirm],
  );

  const { handleSubmit, control } = useForm({
    mode: 'onChange',
  });

  return (
    <CommonModal
      turnOff={hide}
      onConfirm={handleSubmit(confirmCallback as any)}
      containerClassName={style.modalContainer}
      buttonText={t('SpamReport.submit')}
      headerTitle={t('ReportHiSessionModal.modalTItle')}>
      <div className={style.confirmModalBody}>
        <div className={style.desc}>{t('ReportHiSessionModal.1u7qq7k')}</div>
        <div className={style.reportList}>
          {REPORT_ITEMS.map((item, index) => (
            <Controller
              name={`report.${index}`}
              key={index}
              control={control}
              render={({ field }) => (
                <div className={style.item}>
                  <Checkbox className={style.checkbox} {...field}>
                    <div className={style.checkboxLabel}>
                      <div className={style.itemTitle}>{item.title}</div>
                      {item.desc && <div className={style.itemDesc}>{item.desc}</div>}
                    </div>
                  </Checkbox>
                </div>
              )}
            />
          ))}
        </div>
      </div>
    </CommonModal>
  );
};

export const openReportHiSessionModal = wrapModalPromise<ReportHiSessionModalProp, void>(
  ReportHiSessionModal,
  {
    wrapInCommonModal: false,
  },
);
